// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2nZHV","label":"Radio_label__nd5Dw","checkMark":"Radio_checkMark__3Wlq7","disabled":"Radio_disabled__Y3-Rz"};